import React from 'react'
import ReactPaginate from 'react-paginate'
import { PaginationWrapper } from './styled'
import { INFTPagination } from './INFTPagination'

export default function NFTPagination({ pageCount, perPage, page, pageChange }: INFTPagination) {
  const count = pageCount / perPage
  return count > 1 ? (
    <PaginationWrapper>
      <ReactPaginate
        pageCount={count}
        marginPagesDisplayed={5}
        pageRangeDisplayed={5}
        activeClassName="active"
        disabledClassName="disabled"
        initialPage={page}
        forcePage={page}
        onPageChange={pageChange}
      />
    </PaginationWrapper>
  ) : (
    <React.Fragment />
  )
}
